<template>
	<div>
		<h2 class="mw-h1 mt-3">Request: {{request.title}} </h2>
		<v-sheet class="mt-2 pa-4">
			<v-row>
				<v-col>
					<v-row>
						<v-col cols="12" sm="3">
							<span class="overline">Your reference</span>
							<p class="text-large">{{request.clientReference}}</p>
						</v-col>
						<v-col cols="12" sm="3">
							<span class="overline">Our Reference</span>
							<p class="text-large">{{request.reference}}</p>
						</v-col>
						<v-col cols="12" sm="3">
							<span class="overline">Submitted</span>
							<p class="text-large">{{request.created.toDate() | moment('MMMM Do YYYY, h:mm:ss a')}}</p>
						</v-col>
						<v-col cols="12" sm="3">
							<span class="overline">Status</span>
							<p class="text-large">{{prettyPrint(request.status, "TITLE")}}</p>
						</v-col>
					</v-row>
					<v-row v-if="request.description">
						<v-col cols="12">
							<span class="overline">Description</span>
							<p class="text-large">{{request.description}}</p>
						</v-col>
					</v-row>
					<v-row v-if="request.created">
					</v-row>
					<v-row>
						<v-col cols="6" v-if="organisation">
							<span class="overline">Organisation</span> 
							<p class="text-large">{{organisation.name}} <v-btn icon link v-bind:href="'/edit/organisations/' + organisation.id "><v-icon>mdi-link</v-icon></v-btn></p>
						</v-col>
						<v-col cols="6">
							<span class="overline">Department</span>
							<p class="text-large">{{request.department}}</p>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<span class="overline">Meisterworks Contacts</span>
							<p class="text-large" v-for="contact in admins" :key="contact.id">{{contact.displayName}} {{contact.email}}</p>					
						</v-col>
					</v-row>				
				</v-col>	
			</v-row>
		</v-sheet>
		<h2 class="mw-h1 mt-3">Request Details</h2>
		<v-sheet class="mt-2 pa-4">
			<v-row>
				<v-col>
					<MwDataTable
						:allowHighlight="false"
						:editable="false"
						:showSearch="false"
						id="segmentTable"
						:allowExport="false"
						itemKey="index"
						:columns="segmentColumns"
						:rows="request.segments">			
					</MwDataTable>
				</v-col>
			</v-row>
			<v-row>
				<v-col v-if="request.startDate">
					<span class="overline">Start Date</span>
					<p class="text-large">{{request.startDate.toDate() | moment('MMMM Do YYYY, h:mm:ss a')}}</p>							
				</v-col>
				<v-col v-if="request.endDate">
					<span class="overline">End Date</span>
					<p class="text-large">{{request.endDate.toDate() | moment('MMMM Do YYYY, h:mm:ss a')}}</p>
				</v-col>
			</v-row>
		</v-sheet>
		<h2 class="mw-h1 mt-3">Your Deliverables</h2>
		<v-sheet class="mt-2 pa-4">			
			<v-row>
				<v-col>
					<v-simple-table>
						<thead>
							<tr>
								<th class="text-center">Name</th>
								<th class="text-center">Quantity</th>
								<th class="text-center">Due Date</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(deliverable, index) in request.deliverables" :key="index">
								<td class="pt-2">{{deliverable.name}}</td>
								<td class="pt-2">{{deliverable.quantity}}</td>
								<td class="pt-2">{{deliverable.due.toDate() | moment('MMMM Do YYYY, h:mm:ss a')}}</td>
							</tr>
						</tbody>
					</v-simple-table>
				</v-col>
			</v-row>			
		</v-sheet>
		<h2 class="mw-h1 mt-3">Your Quote</h2>
		<v-sheet class="mt-2 pa-4">
			<v-row>
				<v-col>
					<p class="text-large ml-4" color="secondary">Currency:  {{request.currency}}</p>
					<Quote :request="request" :contract="contract"></Quote>
				</v-col>
			</v-row>
		</v-sheet>
		<v-card-actions class="mt-5">
			<v-spacer></v-spacer>
			<v-btn dark color="red"  v-if=" request.status == 'new' || request.status == 'quoted' || request.status == 'paused' " @click="archiveProject">Archive</v-btn>
			<!-- <v-btn dark color="primary" link :to="'/edit-request/'+request.id">Edit Request</v-btn> -->
			<v-btn dark color="green" v-if=" request.status == 'new' || request.status == 'quoted' || request.status == 'paused' " @click="confirmProject">Confirm Project</v-btn>
		</v-card-actions>
		<v-snackbar v-model="updated" light>
			{{message}}
			<v-btn color="green" text @click="updated = false">Close </v-btn>
		</v-snackbar>			
	</div>

</template>

<script>
	import Vuex from 'vuex';
	
	import MwDataTable from "../tools/MwDataTable.vue";
	import {prettyPrint} from "../../assets/utilities.js"
	import Quote from "../tools/Quote.vue";
	export default {
		name: "ViewRequest",
		props:{
			request: {type: Object}
		},
		computed: {
			...Vuex.mapState({ 
				admins(state){
					const self = this;
					if( !self.request.users ){ return [] }
					var admins = Object.keys(self.request.users).filter( key => self.request.users[key] == 'admin')
					return state.client.admins.filter( o => admins.indexOf(o.id) > -1 )
				},
				contract(state){
					const self = this;
					return state[state.auth.view].contracts.find( o => o.id == self.request.contract )
				}
			}),
			segmentColumns(){
				let cols = [
					{
						value: "title",
						text: "Title",
					},
					{
						value: "sessionType",
						text: "Session Type",
					},
					{
						value: "numberOfSessions",
						text: "# of Sessions",
					},
					{
						value: "numberOfParticipants",
						text: "# of Participants / Session",
					},
					{
						value: "loi",
						text: "Length (mins)",
					},
					{
						value: "participantDescription",
						text: "Participant Description",
					},
				]
				if( this.contract ){
					this.contract.additionalFields.forEach( field => {
						var col = {
							value: field.name,
							text: field.description,
						}
						cols.push(col)
					})
				}
				cols.push({
					value: "desiredSchedule",
					text: "Desired Schedule / Times",
				});
				cols.push({
					value: "notes",
					text: "Notes",
				});
				cols.push({
					value: "recruitment",
					text: "Recruitment Cost",
				});
				cols.push({
					value: "incentive",
					text: "Incentive Cost",
				});
				return cols;
			}			
		},
		data: () => {
			return {
				updated: false,
				message: ''
			}
		},
		methods: {
			prettyPrint: prettyPrint,
			confirmProject(){
				const self = this;
				self.$store.dispatch( "updateDoc",{
					doc: "requests/" + self.request.id,
					action: "update", 
					data: {
						status: "confirmed"
					}
				} ).then( () => {
					self.message = "Project confirmed"
					self.updated = true;
				})

			}, 
			editProject(){

			}, 
			archiveProject(){
				const self = this;
				self.$store.dispatch( "updateDoc",{
					doc: "requests/" + self.request.id,
					action: "update", 
					data: {
						status: "archived"
					}
				} ).then( () => {
					self.message = "Request archived"
					self.updated = true;
				})
			}
		},
		components: {
			Quote: Quote,
			MwDataTable: MwDataTable
		}
	}
</script>